module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_vm._t("default", [_c('h3', [_vm._v("請掃描" + _vm._s(_vm.barcodeTitle) + "條碼")])]), _vm._v(" "), (this.barcodeTitle === '藥單條碼') ? _c('img', {
    staticClass: "med-pack",
    attrs: {
      "src": "/static/img/med_pack.jpg",
      "alt": ""
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f4c4962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/ScanBarcode.vue
// module id = 1448
// module chunks = 1